import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 25px;
    padding: 20px;
    overflow-y: auto;
    height: 100%;
`;

export const SectionTitle = styled.h5`
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0;
`;

export const Card = styled.div`
    background-color: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    padding: 20px 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
`;

export const CardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 18px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
`;

export const CardHeaderTitle = styled.h6`
    font-size: 14px;
    font-weight: 600;
    color: #2c2c2c;
    margin: 0;
    letter-spacing: 0.2px;
`;

export const ResetIconButton = styled.button<{ mainColor: string }>`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background-color: transparent;
    color: ${({ mainColor }) => mainColor};
    border: 1px solid ${({ mainColor }) => mainColor};
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${({ mainColor }) => mainColor};
        color: #fff;
    }

    svg {
        width: 14px;
        height: 14px;
    }
`;

export const SmallToggle = styled.button<{
    isActive: boolean;
    mainColor: string;
}>`
    width: 40px;
    height: 22px;
    border-radius: 11px;
    border: none;
    background-color: ${({ isActive, mainColor }) =>
        isActive ? mainColor : "#ccc"};
    position: relative;
    cursor: pointer;
    transition: background-color 0.2s ease;
    flex-shrink: 0;

    &::after {
        content: "";
        position: absolute;
        top: 2px;
        left: ${({ isActive }) => (isActive ? "20px" : "2px")};
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: white;
        transition: left 0.2s ease;
    }
`;

export const FilterRow = styled.div`
    display: grid;
    grid-template-columns: 50px 1fr 40px 90px;
    align-items: center;
    gap: 16px;
    padding: 12px 8px;
    border-radius: 6px;
    border-bottom: 1px solid #f0f0f0;
    position: relative;
    transition: background-color 0.15s ease;

    &:hover {
        background-color: #fafafa;
    }

    &:last-child {
        border-bottom: none;
    }
`;

export const FilterLabel = styled.span`
    font-size: 14px;
    color: #444;
    font-weight: 500;
`;

export const ColorSwatch = styled.button<{ color: string }>`
    width: 28px;
    height: 28px;
    padding: 0;
    border-radius: 6px;
    background-color: ${({ color }) => color};
    border: 1px solid rgba(0, 0, 0, 0.12);
    box-shadow: inset 0 0 0 2px #fff;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    justify-self: center;

    &:hover {
        transform: scale(1.1);
        box-shadow: inset 0 0 0 2px #fff, 0 2px 8px rgba(0, 0, 0, 0.18);
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid #2196f3;
        outline-offset: 2px;
    }
`;

export const ColorValue = styled.span`
    font-size: 11px;
    color: #999;
    font-family: "SFMono-Regular", Consolas, monospace;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;
